module.exports = __webpack_public_path__ + "static/media/about-us-illustration@2x.8b820ddd.png";